var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 394.895,
    height: 257.807,
    viewBox: "0 0 394.895 257.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_9154",
    x: 62.501,
    y: 34.117,
    width: 236.149,
    height: 184.335,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2b9c3",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_9155",
    x: 123.958,
    y: 41.121,
    width: 146.681,
    height: 127.066,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#929ba8",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "figure-1",
    transform: "translate(-860.401 -194.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44313",
    "data-name": "Path 44313",
    d: "M201.81,12.725c103.265,0,172.145-51.265,172.145,52S253.131,227.311,172.676,219.183,0,167.99,0,64.725,98.545,12.725,201.81,12.725Z",
    transform: "translate(1255.296 413.547) rotate(174)",
    fill: "#f2f6f9",
    opacity: 0.524
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21020",
    "data-name": "Group 21020",
    transform: "translate(873.498 208.515)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9150",
    "data-name": "Rectangle 9150",
    width: 336.16,
    height: 13.999,
    transform: "translate(9.399 179.486)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9151",
    "data-name": "Rectangle 9151",
    width: 307.79,
    height: 6.432,
    transform: "translate(23.584 193.485)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9152",
    "data-name": "Rectangle 9152",
    width: 12.456,
    height: 40.161,
    transform: "translate(28.128 199.917)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9153",
    "data-name": "Rectangle 9153",
    width: 12.456,
    height: 40.161,
    transform: "translate(314.373 199.917)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13.1, -13.69)",
    filter: "url(#Rectangle_9154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9154-2",
    "data-name": "Rectangle 9154",
    width: 144.774,
    height: 92.96,
    rx: 4,
    transform: "translate(118.19 73.8)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    x2: 144.774,
    transform: "translate(105.092 132.417)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_926",
    "data-name": "Ellipse 926",
    cx: 3.801,
    cy: 3.801,
    r: 3.801,
    transform: "translate(173.677 138.914)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44291",
    "data-name": "Path 44291",
    d: "M387.057,266.908s14.173-6.738,14.173-26.465h29.716c0,19.727,14.173,26.465,14.173,26.465Z",
    transform: "translate(-238.609 -87.418)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20992",
    "data-name": "Group 20992",
    transform: "translate(151.549 52.122)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -164.65, -65.81)",
    filter: "url(#Rectangle_9155)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9155-2",
    "data-name": "Rectangle 9155",
    width: 85.306,
    height: 65.691,
    rx: 4,
    transform: "translate(164.65 65.81)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_927",
    "data-name": "Ellipse 927",
    cx: 1.907,
    cy: 1.907,
    r: 1.907,
    transform: "translate(8.056 5.536)",
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_928",
    "data-name": "Ellipse 928",
    cx: 1.907,
    cy: 1.907,
    r: 1.907,
    transform: "translate(13.454 5.536)",
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_929",
    "data-name": "Ellipse 929",
    cx: 1.907,
    cy: 1.907,
    r: 1.907,
    transform: "translate(19.186 5.536)",
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    x2: 85.306,
    transform: "translate(0 14.055)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20993",
    "data-name": "Group 20993",
    transform: "translate(162.202 77.724)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_930",
    "data-name": "Ellipse 930",
    cx: 11.946,
    cy: 11.946,
    r: 11.946,
    transform: "translate(1.59 1.622)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9156",
    "data-name": "Rectangle 9156",
    width: 24.778,
    height: 24.843,
    transform: "translate(1.147 1.147)",
    fill: "none",
    stroke: "#b2b9c3",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9157",
    "data-name": "Rectangle 9157",
    width: 2.293,
    height: 2.293,
    transform: "translate(24.778 24.843)",
    fill: "#e8ebee",
    stroke: "#b2b9c3",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9158",
    "data-name": "Rectangle 9158",
    width: 2.293,
    height: 2.293,
    transform: "translate(24.778)",
    fill: "#e8ebee",
    stroke: "#b2b9c3",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9159",
    "data-name": "Rectangle 9159",
    width: 2.293,
    height: 2.293,
    transform: "translate(24.778 12.421)",
    fill: "#e8ebee",
    stroke: "#b2b9c3",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9160",
    "data-name": "Rectangle 9160",
    width: 2.293,
    height: 2.293,
    transform: "translate(0 12.421)",
    fill: "#e8ebee",
    stroke: "#b2b9c3",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9161",
    "data-name": "Rectangle 9161",
    width: 2.293,
    height: 2.293,
    transform: "translate(0 24.843)",
    fill: "#e8ebee",
    stroke: "#b2b9c3",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9162",
    "data-name": "Rectangle 9162",
    width: 2.293,
    height: 2.293,
    fill: "#e8ebee",
    stroke: "#b2b9c3",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9163",
    "data-name": "Rectangle 9163",
    width: 31.882,
    height: 5.457,
    rx: 0.539,
    transform: "translate(195.653 84.507)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9164",
    "data-name": "Rectangle 9164",
    width: 15.941,
    height: 5.457,
    rx: 0.539,
    transform: "translate(195.653 93.236)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9165",
    "data-name": "Rectangle 9165",
    width: 24.828,
    height: 40.751,
    rx: 1.269,
    transform: "translate(91.751 138.681)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9166",
    "data-name": "Rectangle 9166",
    width: 19.24,
    height: 30.008,
    rx: 0.134,
    transform: "translate(94.546 141.502)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_931",
    "data-name": "Ellipse 931",
    cx: 1.677,
    cy: 1.677,
    r: 1.677,
    transform: "translate(102.489 173.821)",
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44292",
    "data-name": "Path 44292",
    d: "M505.584,267.628H481.617l-3.029-28.482h30.025Z",
    transform: "translate(-191.616 -88.084)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9167",
    "data-name": "Rectangle 9167",
    width: 33.559,
    height: 4.545,
    rx: 0.361,
    transform: "translate(285.205 146.516)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20994",
    "data-name": "Group 20994",
    transform: "translate(297.647 102.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44293",
    "data-name": "Path 44293",
    d: "M489.062,209.669c5.3,13.755-8.716,27.511-1.1,41.266h4.026c-7.62-13.755,6.393-27.511,1.1-41.266C491.653,206.547,488.068,206.547,489.062,209.669Z",
    transform: "translate(-485.642 -207.328)",
    fill: "#f2f6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44294",
    "data-name": "Path 44294",
    d: "M489.062,209.669c5.3,13.755-8.716,27.511-1.1,41.266h4.026c-7.62-13.755,6.393-27.511,1.1-41.266C491.653,206.547,488.068,206.547,489.062,209.669Z",
    transform: "translate(-485.642 -207.328)",
    fill: "none",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20995",
    "data-name": "Group 20995",
    transform: "translate(306.705 106.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44295",
    "data-name": "Path 44295",
    d: "M499.719,217.858c-2.8,2.8-8.021,2.129-8.021,2.129s-.673-5.218,2.129-8.021,8.021-2.129,8.021-2.129S502.522,215.057,499.719,217.858Z",
    transform: "translate(-491.627 -209.766)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    y1: 7.094,
    x2: 7.094,
    transform: "translate(0.071 3.127)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20996",
    "data-name": "Group 20996",
    transform: "translate(301.985 128.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44296",
    "data-name": "Path 44296",
    d: "M496.6,232.646c-2.8,2.8-8.021,2.129-8.021,2.129s-.675-5.22,2.128-8.021,8.021-2.129,8.021-2.129S499.4,229.843,496.6,232.646Z",
    transform: "translate(-488.508 -224.554)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286",
    "data-name": "Line 286",
    y1: 7.094,
    x2: 7.094,
    transform: "translate(0.071 3.127)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20997",
    "data-name": "Group 20997",
    transform: "translate(288.815 116.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44297",
    "data-name": "Path 44297",
    d: "M482,224.612c2.8,2.8,8.021,2.128,8.021,2.128s.675-5.218-2.128-8.021-8.021-2.128-8.021-2.128S479.2,221.809,482,224.612Z",
    transform: "translate(-479.806 -216.52)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_287",
    "data-name": "Line 287",
    x1: 7.094,
    y1: 7.094,
    transform: "translate(3.127 3.126)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20999",
    "data-name": "Group 20999",
    transform: "translate(219.071 96.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44298",
    "data-name": "Path 44298",
    d: "M435.765,203.062l15.311,4.445a4.972,4.972,0,0,1,2.679,1.383l29.994,30a3.671,3.671,0,0,1,0,5.191l-8.988,8.988a3.671,3.671,0,0,1-5.191,0L439.576,223.07a4.969,4.969,0,0,1-1.385-2.679l-4.443-15.311A1.749,1.749,0,0,1,435.765,203.062Z",
    transform: "translate(-433.722 -203.036)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20998",
    "data-name": "Group 20998",
    transform: "translate(3.824 3.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9168",
    "data-name": "Rectangle 9168",
    d: "M0,0H6.664a0,0,0,0,1,0,0V32.781a1.958,1.958,0,0,1-1.958,1.958H1.958A1.958,1.958,0,0,1,0,32.781V0A0,0,0,0,1,0,0Z",
    transform: "translate(33.988 29.276) rotate(135)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9169",
    "data-name": "Rectangle 9169",
    d: "M0,0H6.664a0,0,0,0,1,0,0V32.781a1.958,1.958,0,0,1-1.958,1.958H1.958A1.958,1.958,0,0,1,0,32.781V0A0,0,0,0,1,0,0Z",
    transform: "translate(38.7 24.564) rotate(135)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9170",
    "data-name": "Rectangle 9170",
    d: "M0,0H6.664a0,0,0,0,1,0,0V32.781a1.958,1.958,0,0,1-1.958,1.958H1.958A1.958,1.958,0,0,1,0,32.781V0A0,0,0,0,1,0,0Z",
    transform: "translate(29.276 33.988) rotate(135)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9171",
    "data-name": "Rectangle 9171",
    width: 20.022,
    height: 4.361,
    transform: "translate(45.607 31.473) rotate(135)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44299",
    "data-name": "Path 44299",
    d: "M442.348,204.973l-6.583-1.911a1.749,1.749,0,0,0-2.017,2.019l1.91,6.583Z",
    transform: "translate(-433.722 -203.036)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21000",
    "data-name": "Group 21000",
    transform: "translate(202.252 166.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9172",
    "data-name": "Rectangle 9172",
    d: "M0,0H2.2A1.278,1.278,0,0,1,3.475,1.278V67.01a1.148,1.148,0,0,1-1.148,1.148H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(68.158 9.484) rotate(90)",
    fill: "#e8ebee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9173",
    "data-name": "Rectangle 9173",
    width: 12.959,
    height: 68.158,
    rx: 1.205,
    transform: "translate(68.158 0) rotate(90)",
    fill: "none",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_288",
    "data-name": "Line 288",
    y1: 4.448,
    transform: "translate(2.954 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_289",
    "data-name": "Line 289",
    y1: 4.448,
    transform: "translate(6.206 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_290",
    "data-name": "Line 290",
    y1: 6.95,
    transform: "translate(9.458 6.008)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_291",
    "data-name": "Line 291",
    y1: 4.448,
    transform: "translate(12.71 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_292",
    "data-name": "Line 292",
    y1: 4.448,
    transform: "translate(15.962 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_293",
    "data-name": "Line 293",
    y1: 6.95,
    transform: "translate(19.214 6.008)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294",
    "data-name": "Line 294",
    y1: 4.448,
    transform: "translate(22.466 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_295",
    "data-name": "Line 295",
    y1: 4.448,
    transform: "translate(25.718 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_296",
    "data-name": "Line 296",
    y1: 6.95,
    transform: "translate(28.97 6.008)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_297",
    "data-name": "Line 297",
    y1: 4.448,
    transform: "translate(32.222 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_298",
    "data-name": "Line 298",
    y1: 4.448,
    transform: "translate(35.474 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_299",
    "data-name": "Line 299",
    y1: 6.95,
    transform: "translate(38.726 6.008)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_300",
    "data-name": "Line 300",
    y1: 4.448,
    transform: "translate(41.978 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301",
    "data-name": "Line 301",
    y1: 4.448,
    transform: "translate(45.23 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    y1: 6.95,
    transform: "translate(48.482 6.008)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303",
    "data-name": "Line 303",
    y1: 4.448,
    transform: "translate(51.734 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304",
    "data-name": "Line 304",
    y1: 4.448,
    transform: "translate(54.986 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305",
    "data-name": "Line 305",
    y1: 6.95,
    transform: "translate(58.238 6.008)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    y1: 4.448,
    transform: "translate(61.49 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    y1: 4.448,
    transform: "translate(64.741 8.511)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21021",
    "data-name": "Group 21021",
    transform: "translate(34.356 79.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44300",
    "data-name": "Path 44300",
    d: "M383.938,209.862l-3.247,2.95a11.6,11.6,0,0,1,0,3.689l3.247,2.953a1.683,1.683,0,0,1,.441,1.77,23.872,23.872,0,0,1-1.18,2.582l-.293.59a18.642,18.642,0,0,1-1.7,2.289,1.625,1.625,0,0,1-1.77.515l-4.133-1.327a15.453,15.453,0,0,1-3.245,1.917L371.172,232a1.824,1.824,0,0,1-1.327,1.329,22.983,22.983,0,0,1-3.247.22,20.34,20.34,0,0,1-3.024-.22,1.84,1.84,0,0,1-1.4-1.329l-.887-4.206a13.346,13.346,0,0,1-3.246-1.917l-4.132,1.327a1.627,1.627,0,0,1-1.772-.515,13.8,13.8,0,0,1-1.622-2.289l-.37-.59a24.235,24.235,0,0,1-1.18-2.582,1.684,1.684,0,0,1,.442-1.77l3.247-2.953a11.607,11.607,0,0,1,0-3.689l-3.247-2.95a1.686,1.686,0,0,1-.442-1.772,24.406,24.406,0,0,1,1.18-2.582l.37-.592a13.943,13.943,0,0,1,1.622-2.287,1.634,1.634,0,0,1,1.772-.515l4.132,1.327a13.466,13.466,0,0,1,3.246-1.917l.887-4.206a1.684,1.684,0,0,1,1.4-1.255,15.8,15.8,0,0,1,3.1-.295,17,17,0,0,1,3.174.295,1.659,1.659,0,0,1,1.327,1.255l.887,4.206a15.614,15.614,0,0,1,3.245,1.917l4.133-1.327a1.632,1.632,0,0,1,1.77.515,18.916,18.916,0,0,1,1.7,2.287l.293.592a24.038,24.038,0,0,1,1.18,2.582A1.685,1.685,0,0,1,383.938,209.862Z",
    transform: "translate(-348.879 -195.769)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44301",
    "data-name": "Path 44301",
    d: "M365.355,212.794a5.936,5.936,0,0,0,1.7-4.206,5.9,5.9,0,0,0-11.8,0,5.9,5.9,0,0,0,10.107,4.206Z",
    transform: "translate(-343.357 -189.774)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21002",
    "data-name": "Group 21002",
    transform: "translate(30.886 136.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9174",
    "data-name": "Rectangle 9174",
    d: "M0,0H20.325a0,0,0,0,1,0,0V12.82a6.193,6.193,0,0,1-6.193,6.193H6.193A6.193,6.193,0,0,1,0,12.82V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 24.118)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9175",
    "data-name": "Rectangle 9175",
    d: "M0,0H3.51A1.319,1.319,0,0,1,4.829,1.319v3.26A3.191,3.191,0,0,1,1.638,7.77H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(20.325 26.506)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9176",
    "data-name": "Rectangle 9176",
    d: "M.732,0h18.86a.732.732,0,0,1,.732.732V4.011a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.732A.732.732,0,0,1,.732,0Z",
    transform: "translate(0 20.159)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21001",
    "data-name": "Group 21001",
    transform: "translate(4.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44302",
    "data-name": "Path 44302",
    d: "M317.927,229.463c1.215,9.115-5.4,8.912-1.33,17.285",
    transform: "translate(-310.391 -229.463)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44303",
    "data-name": "Path 44303",
    d: "M321.12,231.917c-.406,5.805-4.861,4.929-1.824,13.637",
    transform: "translate(-308.858 -228.203)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44304",
    "data-name": "Path 44304",
    d: "M314.918,231.917c-.4,5.805-4.861,4.929-1.822,13.637",
    transform: "translate(-312.041 -228.203)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21016",
    "data-name": "Group 21016",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21005",
    "data-name": "Group 21005",
    transform: "translate(21.353 6.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44306",
    "data-name": "Path 44306",
    d: "M319.956,144.8c-2.8,2.8-8.021,2.129-8.021,2.129s-.675-5.22,2.128-8.021,8.021-2.129,8.021-2.129S322.759,142,319.956,144.8Z",
    transform: "translate(-311.864 -136.707)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316",
    "data-name": "Line 316",
    y1: 7.094,
    x2: 7.094,
    transform: "translate(0.071 3.127)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21006",
    "data-name": "Group 21006",
    transform: "translate(6.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44307",
    "data-name": "Path 44307",
    d: "M310.4,134.391c2.8,2.8,2.128,8.021,2.128,8.021s-5.218.673-8.021-2.128-2.128-8.021-2.128-8.021S307.6,131.588,310.4,134.391Z",
    transform: "translate(-302.309 -132.192)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    x1: 7.094,
    y1: 7.094,
    transform: "translate(3.127 3.126)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9180",
    "data-name": "Rectangle 9180",
    d: "M0,0H20.325a0,0,0,0,1,0,0V12.82a6.193,6.193,0,0,1-6.193,6.193H6.193A6.193,6.193,0,0,1,0,12.82V0A0,0,0,0,1,0,0Z",
    transform: "translate(8.847 24.771)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9181",
    "data-name": "Rectangle 9181",
    d: "M.732,0h18.86a.732.732,0,0,1,.732.732V4.011a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.732A.732.732,0,0,1,.732,0Z",
    transform: "translate(8.847 20.812)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9182",
    "data-name": "Rectangle 9182",
    width: 98.75,
    height: 7.945,
    transform: "translate(0 43.539)",
    fill: "#e8ebee",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21007",
    "data-name": "Group 21007",
    transform: "translate(9.943 51.24)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    y2: 5.472,
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319",
    "data-name": "Line 319",
    y2: 5.472,
    transform: "translate(78.863)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21009",
    "data-name": "Group 21009",
    transform: "translate(78.801 5.121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9183",
    "data-name": "Rectangle 9183",
    width: 10.005,
    height: 38.418,
    rx: 0.856,
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21008",
    "data-name": "Group 21008",
    transform: "translate(2.512 5.802)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_320",
    "data-name": "Line 320",
    x2: 4.981,
    transform: "translate(0 26.815)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    x2: 4.981,
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21011",
    "data-name": "Group 21011",
    transform: "translate(68.796 13.208)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9184",
    "data-name": "Rectangle 9184",
    width: 10.005,
    height: 30.449,
    rx: 0.856,
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21010",
    "data-name": "Group 21010",
    transform: "translate(2.512 4.598)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_322",
    "data-name": "Line 322",
    x2: 4.981,
    transform: "translate(0 21.252)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323",
    "data-name": "Line 323",
    x2: 4.981,
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21013",
    "data-name": "Group 21013",
    transform: "translate(38.348 36.852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9185",
    "data-name": "Rectangle 9185",
    width: 6.687,
    height: 30.449,
    rx: 0.856,
    transform: "translate(30.449 0) rotate(90)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21012",
    "data-name": "Group 21012",
    transform: "translate(4.598 1.679)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_324",
    "data-name": "Line 324",
    y2: 3.33,
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325",
    "data-name": "Line 325",
    y2: 3.33,
    transform: "translate(21.253)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21015",
    "data-name": "Group 21015",
    transform: "translate(55.544 13.437)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9186",
    "data-name": "Rectangle 9186",
    width: 5.151,
    height: 23.454,
    rx: 0.856,
    transform: "matrix(0.932, 0.362, -0.362, 0.932, 8.486, 0)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21014",
    "data-name": "Group 21014",
    transform: "translate(2.487 3.77)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_326",
    "data-name": "Line 326",
    x2: 2.391,
    y2: 0.928,
    transform: "translate(0 15.261)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327",
    "data-name": "Line 327",
    x2: 2.391,
    y2: 0.928,
    transform: "translate(5.923)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9187",
    "data-name": "Rectangle 9187",
    d: "M1.021,0H2.068A1.021,1.021,0,0,1,3.089,1.021V19.258a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1.021A1.021,1.021,0,0,1,1.021,0Z",
    transform: "translate(17.465 1.555)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21019",
    "data-name": "Group 21019",
    transform: "translate(257.173 4.887)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9188",
    "data-name": "Rectangle 9188",
    width: 32.188,
    height: 42.826,
    rx: 1.899,
    transform: "translate(46.163)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9189",
    "data-name": "Rectangle 9189",
    width: 25.89,
    height: 30.738,
    rx: 1.899,
    transform: "translate(14.842 48.219)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9190",
    "data-name": "Rectangle 9190",
    width: 25.89,
    height: 35.767,
    rx: 1.899,
    transform: "translate(84.317 22.621)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9191",
    "data-name": "Rectangle 9191",
    width: 40.732,
    height: 26.284,
    rx: 1.899,
    transform: "translate(0 16.542)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9192",
    "data-name": "Rectangle 9192",
    width: 32.188,
    height: 23.369,
    rx: 1.899,
    transform: "translate(46.431 48.219)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44308",
    "data-name": "Path 44308",
    d: "M503.463,152.153l1.818,3.679a.817.817,0,0,0,.617.45l4.062.59a.822.822,0,0,1,.454,1.4l-2.939,2.863a.828.828,0,0,0-.236.728l.695,4.044a.821.821,0,0,1-1.191.866l-3.634-1.91a.822.822,0,0,0-.764,0l-3.632,1.91a.821.821,0,0,1-1.191-.866l.693-4.044a.82.82,0,0,0-.236-.728l-2.938-2.863a.822.822,0,0,1,.454-1.4l4.062-.59a.817.817,0,0,0,.617-.45l1.816-3.679A.82.82,0,0,1,503.463,152.153Z",
    transform: "translate(-440.47 -137.869)",
    fill: "#e8ebee",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44309",
    "data-name": "Path 44309",
    d: "M472.044,156.968l-6.451,3.107L464,167.055l4.464,5.6h7.16l4.464-5.6-1.593-6.98Z",
    transform: "translate(-456.279 -135.162)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44310",
    "data-name": "Path 44310",
    d: "M479.538,157.856l-3.435,2.5,1.312,4.038h4.246l1.312-4.038Z",
    transform: "translate(-450.064 -134.706)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21017",
    "data-name": "Group 21017",
    transform: "translate(22.423 56.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44311",
    "data-name": "Path 44311",
    d: "M475.436,191.139a5.548,5.548,0,0,0,7.847-.189l-8.036-7.658A5.548,5.548,0,0,0,475.436,191.139Z",
    transform: "translate(-473.714 -177.798)",
    fill: "#e8ebee",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44312",
    "data-name": "Path 44312",
    d: "M482.327,181.194a5.55,5.55,0,0,0-7.847.191l8.036,7.656A5.551,5.551,0,0,0,482.327,181.194Z",
    transform: "translate(-473.321 -179.662)",
    fill: "#e8ebee",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9193",
    "data-name": "Rectangle 9193",
    width: 9.279,
    height: 9.279,
    transform: "translate(62.257 53.013) rotate(45)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21018",
    "data-name": "Group 21018",
    transform: "translate(90.403 35.117)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9194",
    "data-name": "Rectangle 9194",
    width: 13.718,
    height: 4.041,
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9195",
    "data-name": "Rectangle 9195",
    width: 8.659,
    height: 4.041,
    transform: "translate(0 6.735)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPage);
export default __webpack_public_path__ + "static/media/emptyPage.813000432ca994808e935ddab46f6ce7.svg";
export { ForwardRef as ReactComponent };